import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'gatsby';
import { Button, Card } from '@printdeal/ui-library';
import { LinkedSupportArticle } from '../../types/helpCenter/helpCenter';
import { dispatchDataLayerEntry } from '../../helpers/dataLayerHelpers/productDataLayerHelper';
import ContentfulCardImage from '../ContentfulCardImage';

interface Props {
  linkedArticle: LinkedSupportArticle;
  pageName: string;
}

const trackClick = (pageName: string) =>
  dispatchDataLayerEntry(pageName, 'click', { 'element-type': 'Support article card' });

export const SupportArticleCard = ({ linkedArticle, pageName }: Props) => (
  <Card
    className="pd-h-full"
    image={linkedArticle.featuredImage && (
      <ContentfulCardImage
        src={linkedArticle.featuredImage.url}
        alt={linkedArticle.featuredImage.title}
        aspectRatio={16 / 9}
      />
    )}
    title={linkedArticle.title}
    link={<Link to={linkedArticle.path} onClick={() => trackClick(pageName)} />}
  >
    <p>{linkedArticle?.featuredDescription?.featuredDescription}</p>
    <div className="pd-mt-auto pd-flex pd-w-full pd-content-end pd-justify-end">
      <Button variant="secondary" onClick={() => trackClick(pageName)}>
        <FormattedMessage id="general.view" defaultMessage="View" />
      </Button>
    </div>
  </Card>
);
